// ======================================================================
// File Name       : ChildUserSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { FormControl, Form, Col, Button } from 'react-bootstrap';
import PaginationCustom from '../Pagination';
import CustomButton from '../button/CustomButton';

const ChildUserSearch = ({
  startPosition,
  recordNum,
  onHandleChange,
  onSearchData,
  getStartEndData,
}) =>
  (<Col sm={12}>
    <Form className='form-horizontal'>
      <Form.Group>
        <Col as={Form.Label} sm={2} className="text-left">
          ユーザー名
        </Col>
        <Col sm={8}>
          <FormControl type="text" name="userName" onChange={onHandleChange} />
        </Col>
      </Form.Group>
      <Form.Group>
        <Col as={Form.Label} sm={2} className="text-left">
          ログインID
        </Col>
        <Col sm={8}>
          <FormControl type="text" name="loginId" onChange={onHandleChange} />
        </Col>
      </Form.Group>
      <Form.Group>
        <Col sm={12} className="text-center">
          {/* <Button onClick={onSearchData} bsStyle="primary" className="btn-96">
            
          </Button> */}
          <CustomButton
            btnStyle="btn btn-primary btn-96"
            handleClick={onSearchData}
            text="検索"
            iconClass="bi bi-search"
          />
        </Col>
      </Form.Group>
      <Form.Group className="margin-top-20">
        <Col sm={12}>
          <PaginationCustom
            startPosition={startPosition}
            recordNum={recordNum}
            handlePageSelect={getStartEndData}
            className="float-end"
          />
        </Col>
      </Form.Group>
    </Form>
  </Col>);

export default ChildUserSearch;
